import styled from '@emotion/styled';

interface DescriptionInputProps {
  error?: boolean;
}

export const Container = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
  width: ${({ width = '380px' }) => width};
  margin: 5px;
`;

export const SkillContainer = styled.div(() => ({
  padding: '10px',
  border: '2px solid #ddd',
  marginTop: '8px',
  borderRadius: '10px',
  backgroundColor: '#f9f9f9',
}));

export const Description = styled.p(() => ({
  fontSize: '16px',
  margin: 0,
  overflow: 'hidden',
}));

export const EmptyMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 10px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
  border-radius: 5px;
  background-color: #f9f9f9;
  margin-top: 5px;
`;

export const EmptyMessageText = styled.span({
  alignSelf: 'center',
});

export const DescriptionInput = styled.textarea<DescriptionInputProps>(({ error }) => ({
  fontSize: '16px',
  margin: 0,
  border: error ? '1px solid red' : 'none',
  backgroundColor: 'transparent',
  width: '100%',
  outline: 'none',
  padding: '8px',
  borderRadius: '4px',
}));

